package com.ijoin.platform

actual fun getLocalCurrency(): Currency {
    return try {
        // Get user's locale
        val locale = js("navigator.language || navigator.userLanguage") as? String ?: "en-US"

        // Try to determine currency from locale first
        var currencyCode = getCurrencyFromLocale(locale)

        // Fallback to timezone if locale doesn't give specific currency
        if (currencyCode == null) {
            val timeZone = js("Intl.DateTimeFormat().resolvedOptions().timeZone") as? String
            currencyCode = timeZone?.let { getCurrencyFromTimeZone(it) }
        }

        // Find matching currency from list
        getAllCurrencies().find { it.code == (currencyCode ?: "USD") } ?: Currency("USD", "$", "US Dollar")
    } catch (e: Exception) {
        Currency("USD", "$", "US Dollar")
    }
}

private fun getCurrencyFromLocale(locale: String): String? {
    return when {
        locale.contains("-RU", ignoreCase = true) || locale.startsWith("ru") -> "RUB"
        locale.contains("-GB", ignoreCase = true) -> "GBP"
        locale.contains("-CA", ignoreCase = true) -> "CAD"
        locale.contains("-AU", ignoreCase = true) -> "AUD"
        locale.contains("-NZ", ignoreCase = true) -> "NZD"
        locale.contains("-JP", ignoreCase = true) || locale.startsWith("ja") -> "JPY"
        locale.contains("-CN", ignoreCase = true) || locale.startsWith("zh") -> "CNY"
        locale.contains("-IN", ignoreCase = true) || locale.startsWith("hi") -> "INR"
        locale.contains("-CH", ignoreCase = true) -> "CHF"
        locale.contains("-BR", ignoreCase = true) || locale.startsWith("pt-BR") -> "BRL"
        locale.contains("-MX", ignoreCase = true) -> "MXN"
        locale.contains("-KR", ignoreCase = true) || locale.startsWith("ko") -> "KRW"
        locale.contains("-AE", ignoreCase = true) || locale.startsWith("ar-AE") -> "AED"
        locale.contains("-DE", ignoreCase = true) || locale.contains("-FR", ignoreCase = true) ||
        locale.contains("-IT", ignoreCase = true) || locale.contains("-ES", ignoreCase = true) ||
        locale.contains("-NL", ignoreCase = true) || locale.contains("-PT", ignoreCase = true) -> "EUR"
        locale.contains("-US", ignoreCase = true) -> "USD"
        else -> null
    }
}

private fun getCurrencyFromTimeZone(timeZone: String): String? {
    return timeZoneToCurrency[timeZone]
        ?: timeZonePrefixToCurrency.entries.firstOrNull { timeZone.startsWith(it.key) }?.value
}

private val timeZoneToCurrency = mapOf(
    // Russia
    "Europe/Moscow" to "RUB",
    "Europe/Kaliningrad" to "RUB",
    "Europe/Samara" to "RUB",
    "Asia/Yekaterinburg" to "RUB",
    "Asia/Novosibirsk" to "RUB",
    "Asia/Krasnoyarsk" to "RUB",
    "Asia/Irkutsk" to "RUB",
    "Asia/Vladivostok" to "RUB",
    "Asia/Magadan" to "RUB",
    "Asia/Kamchatka" to "RUB",
    // Europe
    "Europe/London" to "GBP",
    "Europe/Zurich" to "CHF",
    // Asia
    "Asia/Tokyo" to "JPY",
    "Asia/Shanghai" to "CNY",
    "Asia/Hong_Kong" to "HKD",
    "Asia/Singapore" to "SGD",
    "Asia/Seoul" to "KRW",
    "Asia/Kolkata" to "INR",
    "Asia/Dubai" to "AED",
    // Americas
    "America/Sao_Paulo" to "BRL",
    "America/Mexico_City" to "MXN",
    "America/Toronto" to "CAD",
    "America/Vancouver" to "CAD",
    "America/Montreal" to "CAD",
    // Oceania
    "Australia/Sydney" to "AUD",
    "Australia/Melbourne" to "AUD",
    "Pacific/Auckland" to "NZD"
)

private val timeZonePrefixToCurrency = mapOf(
    "Europe/" to "EUR",
    "America/" to "USD",
    "Australia/" to "AUD"
)

actual fun getAllCurrencies(): List<Currency> {
    return listOf(
        Currency("USD", "$", "US Dollar"),
        Currency("CAD", "$", "Canadian Dollar"),
        Currency("EUR", "€", "Euro"),
        Currency("GBP", "£", "British Pound"),
        Currency("CNY", "¥", "Chinese Yuan"),
        Currency("RUB", "₽", "Russian Ruble"),
        Currency("JPY", "¥", "Japanese Yen"),
        Currency("CNY", "¥", "Chinese Yuan"),
        Currency("INR", "₹", "Indian Rupee"),
        Currency("CAD", "$", "Canadian Dollar"),
        Currency("AUD", "$", "Australian Dollar"),
        Currency("CHF", "Fr", "Swiss Franc")
    )
}





